/**
 * Document Status Enum
 *
 * Values synced with backend DocumentStatusEnum.
 * @see backend/src/backend/db/models/account_document.py
 *
 * IMPORTANT: Documents are NOT individually approved/rejected.
 * Documents are items required to evaluate and approve the INSTITUTION.
 * The document status only tracks validity based on expiration date:
 * - APPROVED (2) - Document uploaded and valid (default on upload)
 * - EXPIRED (4) - Document has passed its expiration date
 *
 * Legacy values (not used):
 * - PENDING_REVIEW (1) - Legacy, kept for backward compat
 * - REJECTED (3) - Legacy, kept for backward compat
 */
import { intl } from "dmsbasereact";

export const DocumentStatusEnum = {
    PENDING_REVIEW: 1,  // Legacy - not used (kept for backward compat)
    APPROVED: 2,        // Document valid (default on upload)
    REJECTED: 3,        // Legacy - not used (kept for backward compat)
    EXPIRED: 4,         // Document expired (based on expiration_date)
};

export const DocumentStatus = {
    getText: (code) => {
        switch (code) {
            case DocumentStatusEnum.APPROVED:
                return intl.get("Valid").d("Valid");
            case DocumentStatusEnum.EXPIRED:
                return intl.get("Expired").d("Expired");
            default:
                return intl.get("Valid").d("Valid");
        }
    },
    getColor: (code) => {
        switch (code) {
            case DocumentStatusEnum.APPROVED:
                return "success";
            case DocumentStatusEnum.EXPIRED:
                return "error";
            default:
                return "success";
        }
    }
};

/**
 * Get document status options for select components
 * @returns {Array} Array of {value, label} objects
 */
export const getDocumentStatusOptions = () => [
    { value: DocumentStatusEnum.APPROVED, label: DocumentStatus.getText(DocumentStatusEnum.APPROVED) },
    { value: DocumentStatusEnum.EXPIRED, label: DocumentStatus.getText(DocumentStatusEnum.EXPIRED) },
];
